<template>
    <div>
        <!-- Mobile -->
        <Mobile
            v-if="$vuetify.breakpoint.mobile"
        />

        <!-- Pc -->
        <Pc
            v-if="!$vuetify.breakpoint.mobile"
        />
    </div>
</template>
<script>
import Mobile from './Header/Mobile'
import Pc from './Header/Pc'

export default {
    components: {
        Mobile,
        Pc
    }
}
</script>